import React, {Component} from 'react';
import ReactTooltip from 'react-tooltip'
import InfoCircle from '../../common/InfoCircle';
import CustomFB from './CustomFB';
import FacebookMultiplePostPreview from './FacebookMultiplePostPreview';
import {NavLink} from 'react-router-dom';
import {Picker} from "emoji-mart";
import {MultiSelect} from "@blueprintjs/select";
import {Callout, MenuItem, Position, Switch, Tag, Tooltip} from "@blueprintjs/core";
import EmojiTextArea from "../../common/EmojiTextArea";
import {CSSTransition} from "react-transition-group";
import UpsellModal from "../../modals/UpsellModal";
import PaymentMissingModal from "../../modals/PaymentMissingModal";
import UpsellModalTailwind from "../../modals/UpsellModalTailwind";

//import $ from 'jquery';

class FacebookMultiplePost extends Component {
    state = {
        selectedTags: [],
        enableTags: false,
        sendToAll: true,
        numberOfPosts: 2,
        visiblePost: 0,
        payment: [],
        loading_title_multiple_custom: [
            {
                loading_title: false
            },
            {
                loading_title: false
            }
        ],
        multiple_custom: [],
        pageIsConnected: false,
        selectedWhen: 'Immediately',

        //limitation parameters
        freeMessages: '',
        sourcePlan: this.props.sourcePlan,
        upgradeModalActive: false,
        upgradeModalTitle: '',
        upgradeModalContent: '',
        firstMount: true,
        currentPlanLimitations: this.props.currentPlanLimitations,
        selectedSource: this.props.selectedSource,
        selectedSourceFull: [],
        paymentMissingModalActive: false,
        user: this.props.user
    };


    componentDidMount = async () => {
        
        await this.props.resetInvalidLink();
        //indicating if there is at least one connected FB page
        //console.log('page is connected: ', pageIsConnected);
        let selectedSourceFull = await this.state.user.sources.data.filter(
            source => source.id.toString() === this.state.selectedSource
        )
        //console.log('single fb message - selectedSource full: ', selectedSource)
        if (selectedSourceFull[0]) {

            //collecting remaining free messages
            let facebookPlatform = selectedSourceFull[0].platforms.filter(
                platform => platform.platform === 'fb'
            )
            await this.setState({
                multiple_custom: this.props.multiple_custom,
                sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
                freeMessages: facebookPlatform[0] ? facebookPlatform[0].free_messages_remaining : this.state.freeMessages,
                selectedSourceFull,
                payment: selectedSourceFull[0].default_billing_details
            });
            if (this.props.postUrl) {
                await this.props.onBlur(0, this.props.postUrl, 'link')
            }
            if (this.state.freeMessages === 0) {
                this.props.limitReached()
            }
            document.querySelector('input').addEventListener('onBlur', function () {
                //console.log('input detected')
                if (this.value.length > 0) {
                    alert('true')
                }

            });
        }
    }


    upgradeToProFeature = () => {
        //console.log('upgrade to pro modal')
        this.setState({
            upgradeModalActive: true,
            upgradeModalTitle: 'Segmentation is not available on your current plan.',
            upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`
        })
    }

    limitReached = async () => {
        // console.log('limit reached modal - single fb')

        if (this.state.sourcePlan !== '') {
            // console.log('source plan is not "" ')
            await this.setState({
                paymentMissingModalActive: true,
                upgradeModalTitle: <span> You’ve reached your free <br/> Facebook Messenger notifications limit</span>,
                upgradeModalContent: <div className='text-center'>
                    <p className='flag-text'>
                        You've spent your {this.state.selectedSourceFull[0].plan.platform_limits.fb.credits} free
                        Facebook Messenger notifications.
                        To continue sending Facebook Messages, you need to add a default <a
                        href="/billing/payment-methods">payment
                        method.</a> for this workspace!
                    </p>
                    <p className='upgrade-text'>
                        You will be
                        charged <span
                        className='text-bold'>$ {(this.state.selectedSourceFull[0].plan.platform_limits.fb.price / 1000).toFixed(4)} per
                        message</span> (on a thousand messages sent).</p>
                </div>

            })

        }
    }

    componentDidUpdate = async () => {
        if (this.state.multiple_custom !== this.props.multiple_custom) {
            //console.log('selected source id: ', this.props.selectedSource);
            let selectedSource = await this.props.user.sources.data.filter(
                source => source.id.toString() === this.props.selectedSource
            )
            //console.log('selectedSource full: ', selectedSource)
            if (selectedSource[0]) {

                //collecting remaining free messages
                let facebookPlatform = selectedSource[0].platforms.filter(
                    platform => platform.platform === 'fb'
                )
                //console.log('facebook platform :', facebookPlatform);

                await this.setState({
                    sourcePlan: selectedSource[0] ? selectedSource[0].platforms[0].plan : '',
                    freeMessages: facebookPlatform[0] ? facebookPlatform[0].free_messages_remaining : this.state.freeMessages
                })
            }
            if (this.state.freeMessages === 0 && this.state.firstMount === true) {
                //console.log('should run limit reached - will receive')
                //this.limitReached()
                this.setState({
                    firstMount: false
                })
            }
            // if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
            //     this.setState({
            //         currentPlanLimitations: this.props.selectedSourceFull[0].plan,
            //         currentPlatformLimitations: this.props.selectedSourceFull[0].plan.platform_limits.fb
            //     })
            // }

            await this.setState({

                loading_title_multiple_custom: this.props.loading_title_multiple_custom,
                multiple_custom: this.props.multiple_custom

            })

        }
        if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
            await this.setState({currentPlanLimitations: this.props.currentPlanLimitations})
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            let selectedSourceFull = this.state.user.sources.data.filter(source => {
                return source.id.toString() === this.props.selectedSource.toString()
            })
            this.setState({
                selectedSource: this.props.selectedSource,
                selectedSourceFull,
                payment: selectedSourceFull[0].default_billing_details

            })
        }


    };

    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}

                    shouldDismissPopover={true}
                />
            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item '
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    };
    togglesendToAll = () => {
        let sendToAll = !this.state.sendToAll;
        let selectedTags = this.state.selectedTags;
        if (sendToAll === false) {
            selectedTags = []
        }
        //console.log('enable tags:', enableTags);

        this.setState({sendToAll, selectedTags})
    }
    handleTagRemove = async (item) => {
        const selectedTags = this.state.selectedTags;
        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);
        await this.setState({selectedTags: newTags});
    };

    tagSelect = (item) => {
        //console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;
        //console.log('selectedTags beginning: ', selectedTags);

        if (selectedTags.includes(item) === false) {

            //console.log('adding new tag: ', item);

            selectedTags.push(item);
            this.setState({selectedTags: selectedTags});
        } else {

            //console.log('removing tag: ', item)
            const newTags = selectedTags.filter(t => t !== item);
            this.setState({selectedTags: newTags})
        }

    };
    tagRender = (item) => {
        //console.log('rendering tag: ', item);
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
    };

    toggleEnableTags = () => {
        let enableTags = !this.state.enableTags
        let selectedTags = this.state.selectedTags
        if (enableTags === false) {
            selectedTags = []
        }
        //console.log('enable tags:', enableTags);

        this.setState({enableTags, selectedTags})
    }
    multipostSelected = async (postIndex) => {
        //console.log(postIndex.target.id);

        this.setState({visiblePost: Number(postIndex.target.id)})
        //this.returnMultipostButtons()
    };

    returnMultipostButtons = () => {

        let multipostButtons = [];
        let postIndex = 0;
        for (let i = 0; i < this.state.numberOfPosts; i++) {


            multipostButtons.push(<div
                onClick={e => this.multipostSelected(e)}
                id={postIndex}
                className={i === this.state.visiblePost ? 'multipost-button active' : 'multipost-button'}>{i + 1}</div>
            );
            postIndex++
        }
        return multipostButtons
    };

    addMoreMultiposts = async () => {
        this.props.addMorePosts();
        let numberOfPosts = this.state.numberOfPosts;
        if (numberOfPosts < 9) {
            numberOfPosts = numberOfPosts + 1;
        }
        await this.setState({numberOfPosts})
    }


    handleMultipostRemove = async (visiblePost) => {
        let numberOfPosts = await this.state.numberOfPosts;
        numberOfPosts--;
        await this.setState({numberOfPosts});
        await this.props.removeMultipost(visiblePost)
        visiblePost--;
        await this.setState({visiblePost});
        // console.log('handleMultipostRemove: ', numberOfPosts, this.state.visiblePost, this.state.multiple_custom)
    };

    render() {


        let {
            checked_send_all, checked_channels, checkPagesAndChannels, checkAllPagesAndChannels, updateValue, onBlur,
            broadcastClick, selectedSource, addMorePosts, platforms_enabled,
            multiple_custom, pages, handleGetTitleFromUrl, loading_title_multiple_custom, removeMultipost
        } = this.props;
        let source = [];
        //let myData_pages = [];
        if (this.props.sources) {
            source = this.props.sources.filter(source =>
                source.id.toString() === this.props.selectedSource.toString());


        }

        let shared_feed_bool = false;
        // if (source.length === 0) {
        //     source = this.props.user.feeds_shared.filter(source =>
        //         source.project_id.toString() === this.props.selectedSource.toString());
        //
        //     if (source.length) {
        //         shared_feed_bool = true;
        //     }
        // }
        //let source = [];
        ////let myData_pages = [];
        //if (sources) {
        //    source = sources.filter(source =>
        //    source.id.toString() === selectedSource.toString());
        //
        //    //if (source.length > 0) {
        //    //    myData_pages = source[0].user_facebook_pages ? source[0].user_facebook_pages : [];
        //    //    myData_pages["feed_id"] = 11;
        //    //}
        //}

        let facebook_platform_enabled = platforms_enabled && platforms_enabled.indexOf("fb") > -1;
        //console.log(" CustomMultiplePosts facebook_platform_enabled ", facebook_platform_enabled);
        //console.log('pages in render: ', pages);


        let pageIsConnected = false;
        // console.log('pages: ', pages);
        // console.log('pages length:', pages.length);
        //testing is at least one FB page connected
        if (pages.length > 0) {
            pages.map(page => {
                if (page.page_connected === 'Connected') {
                    pageIsConnected = true;
                }
            });
        }
        //console.log('is page connected render:', pageIsConnected);

        return (
            <div id="multiple-posts" className="d-block panel-container campaign-container">
                {this.state.freeMessages === 0 ?
                    <Callout
                        intent='primary'
                        icon='info-sign'
                    >There are no free Facebook Messages left. You will be charged for your campaign at the
                        <span
                            className='text-bold'> $ {this.state.selectedSourceFull[0].plan.platform_limits.fb.price / 1000}</span> per
                        message.
                    </Callout>
                    :
                    ''
                }
                <div className="row posts-columns">
                    <div className="col-md-6 feed-col">
                        <div className="section m-lg-b">
                            <p className='text-bold custom-subtitle'>
                                Carousel Facebook Message
                            </p>
                            <div className="section-container">
                                <div className="form-group m-k-b post-message">
                                    <div className="fb-msg-title">
                                        <label className='m-k-b'>Introduction Message</label>

                                        <CSSTransition>
                                            <div onClick={this.props.toggleMessage}
                                                 className={this.props.showMessage ? 'msg-button remove' : 'msg-button'}>

                                                <div
                                                    className='plus-sign'>+
                                                </div>

                                                <p>{this.props.showMessage ? 'Remove' : 'Add Message'}</p>
                                            </div>
                                        </CSSTransition>
                                    </div>
                                    {this.props.showMessage ?
                                        <EmojiTextArea
                                            uniqueId='introduction'
                                            onUpdate={this.props.handleMessage}

                                            label={'Message'}
                                            placeholder={'Your introduction message goes here'}
                                            height={120}
                                            maxCharacters={125}
                                            infoCircleType={'question'}
                                            infoCircleContent='Message'
                                            showMessagesNumber={false}
                                        />
                                        :
                                        ''
                                    }


                                </div>

                                <div className='multipost-buttons'>
                                    {this.returnMultipostButtons()}
                                    <div className='multipost-button' onClick={this.addMoreMultiposts}>+</div>
                                </div>

                                <div className='remove-multipost '>
                                    {this.state.visiblePost !== 0 && this.state.visiblePost !== 1 ?
                                        <p onClick={() => this.handleMultipostRemove(this.state.visiblePost)}><span
                                            className="far fa-times-circle"></span>Remove</p>
                                        :
                                        ''
                                    }
                                </div>


                                {this.state.multiple_custom.map((post, index) =>
                                    <div key={index}
                                         style={this.state.visiblePost === index ? {display: "block"} : {}}
                                         className={'multiple-post multiple-post-' + index}>
                                        <div className="section-container multiple-section m-lg-b">
                                            <div className="form-group m-k-b">
                                                <p>Post Link</p>
                                                <input
                                                    className={multiple_custom[index] && (multiple_custom[index].link === '') ? 'fb-sponsored-message-input' : 'fb-sponsored-message-input valid'}
                                                    //id={"multiple_custom_0" + index + "_link"}
                                                    value={post.link || ''}
                                                    placeholder="http://example.com/post"
                                                    type="text"
                                                    onBlur={
                                                        (e) => onBlur(index, e.target.value, 'link')
                                                    }
                                                    onChange={(e) => {
                                                        updateValue(post.id, e.target.value, 'link')
                                                    }}/>
                                            </div>
                                            <div className="form-group m-lg-b m-k-b">
                                                <span className="label">Post Title
                                                    <label
                                                        className="right checkbox">
                                                        <Switch
                                                            id={index}
                                                            name={"multiple_custom_0" + (index + 1) + "_title"}
                                                            checked={this.state.multiple_custom[index] && this.state.multiple_custom[index].get_title_from_url}
                                                            label="Fetch the title from the link"
                                                            onChange={handleGetTitleFromUrl}/>

                                                    </label>
                                                </span>

                                                <input

                                                    id={"multiple_custom_0" + index + "_title"}
                                                    name="title"
                                                    placeholder="You can use a fetched default, or change it to a custom title"
                                                    className={this.state.loading_title_multiple_custom[index] &&
                                                    this.state.loading_title_multiple_custom[index].loading_title === true ?
                                                        "fb-sponsored-message-input valid input-loading " : "" +
                                                        multiple_custom && multiple_custom[index] && (multiple_custom[index].title === '') ? 'fb-sponsored-message-input' : 'fb-sponsored-message-input valid'}
                                                    type="text"
                                                    value={post.title}
                                                    onChange={(e) => {
                                                        updateValue(post.id, e.target.value, "title")
                                                    }}/>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                        {!facebook_platform_enabled && !shared_feed_bool ?
                            <div className="section send-to-all m-lg-b">
                                <div className="separator m-m-b"></div>
                                <span className="text-light-grey">To use this feature you must enable the Facebook
                                    channel.
                                    You can do this on the <NavLink to="/channels">Channels </NavLink> page</span>
                            </div>
                            :
                            !pageIsConnected ?
                                <div className="section send-to-all m-lg-b">

                                    <span className="text-light-grey">To send Multiple custom links you must connect at
                                        least one FB page to this workspace.
                                        <br/>
                                        You can do this on the <NavLink
                                            to="/channels">Channels</NavLink> page.</span>
                                </div>
                                :
                                <React.Fragment>

                                    <CustomFB pages={this.props.pages}
                                              selectedSource={this.props.selectedSource}
                                              checkPagesAndChannels={this.props.checkPagesAndChannels}
                                              checked_send_all={this.props.checked_send_all}
                                              checked_channels={this.props.checked_channels}
                                              facebook_platform_enabled={facebook_platform_enabled}/>

                                    <div className="space-between tag-toggle-container">
                                        <p className='text-bold custom-subtitle m-t-b'>Segments</p>
                                        <div className="details-trigger right">

                                            <Switch checked={this.state.sendToAll}
                                                    label="Send to all"
                                                    onChange={this.togglesendToAll}/>
                                        </div>
                                    </div>

                                    <div className="multiselect-container">
                                        {
                                            !this.state.sendToAll ?
                                                <React.Fragment>


                                                    <p className='m-sm-b'>Select Subscribers Subscription Model</p>

                                                    <div id='subscribers-filters' className="custom-post-filters">
                                                        <div onClick={() => this.props.selectSubsFilter('all-subs')}
                                                             className={this.props.subsFilter === 'all-subs' ? "filter active" : "filter"}>
                                                            <label htmlFor="all-subs">All</label>
                                                            <input
                                                                checked={this.props.subsFilter === 'all-subs' ? true : false}
                                                                id='all-subs'
                                                                name='subscription' type='radio' value='all'/>
                                                        </div>
                                                        <div onClick={() => this.props.selectSubsFilter('immediate')}
                                                             className={this.props.subsFilter === 'immediate' ? "filter active" : "filter"}>
                                                            <label htmlFor="immediate">Instant</label>
                                                            <input
                                                                checked={this.props.subsFilter === 'immediate' ? true : false}
                                                                id='immediate'
                                                                name='subscription' type='radio' value='immediate'/>
                                                        </div>
                                                        <div onClick={() => this.props.selectSubsFilter('daily')}
                                                             className={this.props.subsFilter === 'daily' ? "filter active" : "filter"}>
                                                            <label htmlFor="daily">Daily</label>
                                                            <input
                                                                checked={this.props.subsFilter === 'daily' ? true : false}
                                                                id='daily'
                                                                name='subscription' type='radio' value='daily'/>
                                                        </div>
                                                        <div onClick={() => this.props.selectSubsFilter('weekly')}
                                                             className={this.props.subsFilter === 'weekly' ? "filter active" : "filter"}>
                                                            <label htmlFor="weekly">Weekly</label>
                                                            <input
                                                                checked={this.props.subsFilter === 'weekly' ? true : false}
                                                                id='weekly'
                                                                name='subscription' type='radio' value='weekly'/>
                                                        </div>
                                                        <div style={{display: 'none'}}
                                                             onClick={() => this.props.selectSubsFilter('monthly')}
                                                             className={this.props.subsFilter === 'monthly' ? "filter active" : "filter"}>
                                                            <label htmlFor="monthly">Monthly</label>
                                                            <input
                                                                checked={this.props.subsFilter === 'monthly' ? true : false}
                                                                id='monthly'
                                                                name='subscription' type='radio' value='monthly'/>
                                                        </div>
                                                    </div>
                                                    <p className='m-sm-b'>Gender</p>

                                                    <div id='gender-filters' className="custom-post-filters m-lg-b">
                                                        <div
                                                            onClick={() => this.props.selectGenderFilter('all-genders')}
                                                            className={this.props.genderFilter === 'all-genders' ? "filter active" : "filter"}>
                                                            <label htmlFor="all-genders">All</label>
                                                            <input
                                                                checked={this.props.genderFilter === 'all-genders' ? true : false}
                                                                id='all-genders' name='gender' type='radio'
                                                                value='all-gender'/>
                                                        </div>

                                                        <div onClick={() => this.props.selectGenderFilter('male')}
                                                             className={this.props.genderFilter === 'male' ? "filter active" : "filter"}>
                                                            <label htmlFor="male">Male</label>
                                                            <input
                                                                checked={this.props.genderFilter === 'male' ? true : false}
                                                                id='male'
                                                                name='gender' type='radio' value='male'/>
                                                        </div>

                                                        <div onClick={() => this.props.selectGenderFilter('female')}
                                                             className={this.props.genderFilter === 'female' ? "filter active" : "filter"}>
                                                            <label htmlFor="female">Female</label>
                                                            <input
                                                                checked={this.props.genderFilter === 'female' ? true : false}
                                                                id='female'
                                                                name='gender' type='radio' value='female'/>
                                                        </div>

                                                        <div onClick={() => this.props.selectGenderFilter('other')}
                                                             className={this.props.genderFilter === 'other' ? "filter active" : "filter"}>
                                                            <label htmlFor="other">Other</label>
                                                            <input
                                                                checked={this.props.genderFilter === 'other' ? true : false}
                                                                id='other'
                                                                name='gender' type='radio' value='other'/>
                                                        </div>
                                                    </div>

                                                    <p>Sent to audience with these tags</p>
                                                    <MultiSelect
                                                        items={this.props.tags}
                                                        itemRenderer={this.multiMenuItem}
                                                        tagInputProps={{
                                                            placeholder: 'Filter by tag',
                                                            onRemove: this.handleTagRemove
                                                        }}
                                                        resetOnSelect={true}

                                                        className='tag-multiselect custom-posts-tag-filter'
                                                        onItemSelect={this.tagSelect}
                                                        tagRenderer={this.tagRender}
                                                        itemListPredicate={this.props.filterTags}
                                                        selectedItems={this.state.selectedTags}
                                                        fill={true}
                                                        noResults={<MenuItem disabled={true} text="No results."/>}
                                                    />
                                                    {this.state.selectedSourceFull[0].plan.plan_id === 'free_plan' ?

                                                        <Callout
                                                            className='m-lg-t'
                                                            intent='primary'
                                                            icon='info-sign'
                                                        >
                                                            Top up your game. <span className='text-underline'>Pro plans
                                                            only.</span>
                                                            <a className='text-bold' onClick={this.upgradeToProFeature}
                                                               href="#">Go PRO</a>
                                                        </Callout>
                                                        :
                                                        ''
                                                    }
                                                </React.Fragment>
                                                :
                                                ''
                                        }
                                    </div>


                                    {/*{console.log('CustomWebPush props in CustomSinglePosts: ', source, checkPagesAndChannels, checked_send_all, checked_channels, webpush_platform_enabled)}*/}
                                    <p className='custom-subtitle text-bold '>When to send</p>
                                    <div
                                        //onClick={this.handleWhen}
                                        className='flex-direction-row when-to-send m-lg-b'
                                    >
                                        <Tooltip content="Coming Soon!" position={Position.BOTTOM}>
                                            <div
                                                className={this.state.selectedWhen === 'Schedule' ? "when-selection active" : 'when-selection disabled'}>

                                                Schedule

                                            </div>
                                        </Tooltip>
                                        <div
                                            className={this.state.selectedWhen === 'Immediately' ? "when-selection active" : 'when-selection'}>
                                            Immediately
                                        </div>
                                    </div>
                                    <div className="flex-direction-row justify-content-space">

                                        <button className='btn-transparent-border'
                                                onClick={() => this.props.history.push('/new')}>
                                            Cancel
                                        </button>
                                        <button id="broadcast_multiple" className="btn-action"
                                                onClick={
                                                    this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan ?
                                                        this.state.selectedSourceFull[0].plan.additional_features.tags_segmentation === 0 ?
                                                            this.state.sendToAll === false ?
                                                                this.upgradeToProFeature : //if we're actually using

                                                                this.state.freeMessages === 0 ?
                                                                    this.state.payment !== null ?
                                                                        (e) => this.props.broadcastClick(e, this.state.selectedTags) :
                                                                        this.limitReached :
                                                                    (e) => this.props.broadcastClick(e, this.state.selectedTags) :
                                                            this.state.freeMessages === 0 ?
                                                                this.state.payment ?
                                                                    (e) => this.props.broadcastClick(e, this.state.selectedTags) :
                                                                    this.limitReached :
                                                                (e) => this.props.broadcastClick(e, this.state.selectedTags)
                                                        :
                                                        ''

                                                }
                                                disabled={this.props.loaded === 1 ? true : ''}>
                                            Broadcast Now {
                                            this.props.loaded === 1 ?
                                                <i className='fa fa-spin fa-spinner'></i>
                                                :
                                                ""
                                        }
                                        </button>
                                    </div>
                                    <UpsellModalTailwind
                                        showModal={this.state.upgradeModalActive}
                                        handleClose={() => this.setState({upgradeModalActive: false})}
                                        maxWidth={null}
                                        history={this.props.history}
                                        title={this.state.upgradeModalTitle}
                                        content={this.state.upgradeModalContent}
                                        plan={this.state.sourcePlan}
                                        user={this.props.user}
                                    />
                                    <PaymentMissingModal
                                        showModal={this.state.paymentMissingModalActive}
                                        handleClose={() => this.setState({paymentMissingModalActive: false})}
                                        maxWidth={null}
                                        history={this.props.history}
                                        title={this.state.upgradeModalTitle}
                                        content={this.state.upgradeModalContent}
                                        plan={this.state.sourcePlan}
                                        user={this.props.user}

                                    />
                                </React.Fragment>
                        }
                    </div>
                    <FacebookMultiplePostPreview multiple_custom={multiple_custom}
                                                 messageContent={this.props.messageContent}
                                                 {...this.props}/>
                </div>
            </div>
        );
    }
    ;
}


export default FacebookMultiplePost;